import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../logo.png';
import StoreBadges from './StoreBadges';
import { SITE_COPY, SiteLang } from './siteConfig';

const PublicFooter: React.FC<{ lang: SiteLang }> = ({ lang }) => {
  const copy = SITE_COPY[lang];
  return (
    <footer className="home-footer">
      <div className="home-container footer-inner">
        <div className="footer-brand">
          <img src={logo} alt="Fconnect" className="footer-logo" />
          <p className="footer-company"><strong>{copy.company}</strong></p>
          <div className="footer-stores" id="fc-get-app">
            <StoreBadges size="sm" />
          </div>
        </div>
        <div className="footer-contact">
          {copy.contact.map((c) => (
            <p key={c.label}>
              <strong>{c.label}:</strong>{' '}
              {c.href ? <a href={c.href}>{c.value}</a> : c.value}
            </p>
          ))}
        </div>
        <nav className="footer-links" aria-label="Footer">
          {[...copy.nav, ...copy.footerExtra].map((item) => (
            <Link key={item.to} to={item.to}>{item.label}</Link>
          ))}
        </nav>
      </div>
      <div className="copyright">
        <span>{copy.copyright}</span>
        <span className="developed-by">
          {copy.developedBy}{' '}
          <a href="https://www.basecom.vn/" target="_blank" rel="noopener noreferrer">Basecom</a>
        </span>
      </div>
    </footer>
  );
};

export default PublicFooter;
